(() => {
  'use strict';
  let config = {};
  try { config = JSON.parse(document.querySelector('#faith-config')?.textContent || '{}'); } catch {}
  const root = config.root || '/';
  const request = async (route, body) => {
    const response = await fetch(root + route, {
      credentials: 'same-origin',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}),
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('The store could not save this message. Please try again.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'The store could not save this message. Please try again.');
    return data;
  };
  const panel = () => document.querySelector('[data-cart-gift-panel]');
  const toggle = () => document.querySelector('[data-cart-gift-toggle]');
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cart-gift-toggle]');
    if (trigger) {
      const target = panel();
      if (!target) return;
      target.hidden = !target.hidden;
      trigger.setAttribute('aria-expanded', String(!target.hidden));
      if (!target.hidden) {
        const input = document.querySelector('[data-cart-gift-message-input]');
        try {
          const cart = await request('cart.js');
          if (input && document.activeElement !== input) input.value = cart.attributes?.['Gift message'] || '';
        } catch {}
        input?.focus();
      }
      return;
    }
    if (event.target.closest('[data-cart-gift-cancel]')) {
      const target = panel();
      if (target) target.hidden = true;
      toggle()?.setAttribute('aria-expanded', 'false');
      document.querySelector('[data-cart-gift-toggle]')?.focus();
      return;
    }
    if (!event.target.closest('[data-cart-gift-save]')) return;
    const save = event.target.closest('[data-cart-gift-save]');
    const input = document.querySelector('[data-cart-gift-message-input]');
    const error = document.querySelector('[data-cart-gift-error]');
    const message = input?.value.trim() || '';
    if (!input || !save) return;
    save.disabled = true;
    if (error) error.hidden = true;
    try {
      const cart = await request('cart.js');
      const attributes = { ...(cart.attributes || {}) };
      if (message) attributes['Gift message'] = message;
      else delete attributes['Gift message'];
      await request('cart/update.js', { attributes });
      const target = panel();
      if (target) target.hidden = true;
      toggle()?.setAttribute('aria-expanded', 'false');
      const toast = document.querySelector('.faith-toast');
      if (toast) { toast.textContent = message ? 'Gift message saved' : 'Gift message removed'; toast.hidden = false; }
    } catch (exception) {
      if (error) { error.textContent = exception.message; error.hidden = false; }
    } finally { save.disabled = false; }
  });
})();
